import $ from 'jquery';

const Alert = (el) => {
    $(el).find('.js-alert-open').on('click', () => {
        $(el).find('.alert__header').css('display', 'none');
        $(el).find('.alert__content').css('display', 'block');
    });

    $(el).find('.js-alert-close').on('click', () => {
        $(el).find('.alert__header').css('display', 'flex');
        $(el).find('.alert__content').css('display', 'none');
    });
}

export default Alert;
